import cn from "classnames";
import { createElement } from "react";
import { TextProps } from "./types";
import styles from "./styles.module.scss";

export const Text = ({
  children,
  className,
  size = "medium",
  weight = "regular",
  lineHeight = "long",
  htmlTag = "span",
  dataTestId = "text",
  htmlTitle,
}: TextProps) =>
  createElement(
    htmlTag,
    {
      "data-test-id": dataTestId,
      title: htmlTitle,
      className: cn(
        styles.text,
        styles[`size-${size}-${lineHeight}`],
        styles[`weight-${weight}`],
        className
      ),
    },
    children
  );
